//different categories of blogs
export const categories = [
    { id: 1, type: "Academic Life" },
    { id: 2, type: "Campus Life" },
    { id: 3, type: "Career" },
    { id: 4, type: "Technology" },
    { id: 5, type: "Communities" }
];